var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66735 0.457641C2.05716 -0.152547 1.06784 -0.152547 0.457646 0.457641C-0.152549 1.06783 -0.152549 2.05714 0.457646 2.66733L10.2904 12.5L0.457646 22.3327C-0.152548 22.9429 -0.152548 23.9322 0.457646 24.5424C1.06784 25.1525 2.05716 25.1525 2.66735 24.5424L12.5001 14.7097L22.3326 24.5421C22.9428 25.1523 23.9322 25.1523 24.5424 24.5421C25.1525 23.9319 25.1525 22.9426 24.5424 22.3324L14.7098 12.5L24.5424 2.66757C25.1525 2.05738 25.1525 1.06807 24.5424 0.457877C23.9322 -0.152311 22.9428 -0.152311 22.3326 0.457877L12.5001 10.2903L2.66735 0.457641Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseAlt);
export default __webpack_public_path__ + "static/media/close-alt.60b605e93461dc61937c854e9a220f3b.svg";
export { ForwardRef as ReactComponent };